<template>
  <div v-if="name" v-html="require(`@/assets/icons/${name}.svg`)"></div>
</template>

<script>
export default {
  props: {
    name: {
      default: '',
      type: String
    },
    center: {
      default: true,
      type: Boolean
    }
  },

  watch: {
    name () {
      this.$nextTick(() => {
        this.applyClasses()
      })
    }
  },

  mounted () {
    this.applyClasses()
  },

  methods: {
    applyClasses () {
      if (!this.$el.classList) return

      this.$el.classList.add('fill-current')
      if (this.center) {
        this.$el.classList.add('center-y')
      }
    }
  }
}
</script>
